'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Tooltip = require('./Tooltip');

Object.defineProperty(exports, 'Tooltip', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Tooltip).default;
  }
});

var _TooltipTrigger = require('./TooltipTrigger');

Object.defineProperty(exports, 'TooltipTrigger', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_TooltipTrigger).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@wh/ui-components/dist/main/components/tooltip/index.js
// module id = 624
// module chunks = 0